<template>
  <background-animation
    ref="hero"
    :class="$style.root"
  >

    <div :class="$style.row">
      <base-slider
        ref="slick"
        :options="slickOptions"
        :class="$style.slider"
        @init="slickInit"
      >
        <div
          v-for="(item, index) in heroSlides"
          :key="index"
          :class="$style.heroItemWrapper"
        >
          <div :class="$style.heroItem">
            <router-link
              :to="item.to"
              :class="$style.heroLink"
            >
              <h2
                :class="$style.heroTitle"
                v-html="item.title"
              />
              <p
                :class="$style.heroText"
                v-html="item.text"
              />
            </router-link>
          </div>
        </div>
      </base-slider>
    </div>

    <router-link
      :to="projectsUrl"
      :class="$style.heroLink"
    >
      <div :class="$style.row">
        <div :class="$style.heroService">

          <div
            v-for="(item, index) in activities"
            :key="index"
            :class="$style.heroServiceItem"
          >
            <img
              :class="$style.heroServiceImg"
              :src="`/static/${item.icon}`"
              :alt="item.text"
              decoding="async"
            >
            <p :class="$style.heroServiceText">
              {{ item.text }}
            </p>
          </div>

        </div>
      </div>
    </router-link>
  </background-animation>
</template>
<script>
import { PROJECTS, TEAM } from 'router';
import BackgroundAnimation from './BackgroundAnimation';
import BaseSlider from './BaseSlider';

export default {
  name: 'HomeHero',
  components: {
    BackgroundAnimation,
    BaseSlider,
  },
  data() {
    return {
      slickOptions: {
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnFocus: false,
      },
      heroSlides: [
        {
          title: '<span>Очень Интересные </span>проекты',
          text: 'Чистый код и красивые решения',
          to: PROJECTS,
        },
        {
          title: '<span>Отличная </span>команда',
          text: 'Растем вместе!',
          to: TEAM,
        },
        {
          title: '<span>Широкая </span>география',
          text:
            'Работаем в Европе, Азии и Америке. <br>190 профессионалов в 8 офисах по всему миру',
          to: TEAM,
        },
        {
          title: '<span>Обмен </span>опытом',
          text:
            '16 лет успеха, свыше 2070 выполненных проектов, <br>190 профессионалов в 8 офисах по всему миру',
          to: PROJECTS,
        },
        {
          title: '<span>Преимущества </span>роста',
          text:
            'Хорошая зарплата, индивидуальный план роста <br>для каждого, бонусы, вечеринки и вкусный кофе!',
          to: TEAM,
        },
      ],
      activities: [
        {
          icon: 'ic_design.svg',
          text: 'Дизайн',
        },
        {
          icon: 'ic_mob_apps.svg',
          text: 'Приложения',
        },
        {
          icon: 'ic_web.svg',
          text: 'WEB',
        },
      ],
      projectsUrl: PROJECTS,
    };
  },
  methods: {
    slickInit() {
      $(`.${this.$style.slider}`).css({
        maxHeight: '637px',
        visibility: 'visible',
      });
    },
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/helpers';

.root {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 687px;
  padding: 146px 0 64px;
  background-color: $red-dark;

  @include media('<tablet') {
    min-height: 431px;
    padding: 105px 10px 72px;
  }
}

.row {
  position: relative;
  z-index: 1;
  padding: 20px 0;
}

.heroItemWrapper {
  text-align: center;
}

.heroItem {
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  padding: 20px 30px 30px;

  @include media('<tablet') {
    padding: 20px;
  }
}

.heroItem::after,
.heroItem::before {
  content: '';
  position: absolute;
  width: 42px;
  height: 36px;
}

.heroItem::after {
  top: 0;
  left: 0;
  border-top: 1px solid $white;
  border-left: 1px solid $white;
}

.heroItem::before {
  bottom: 0;
  right: 0;
  border-right: 1px solid $white;
  border-bottom: 1px solid $white;
}

.heroTitle {
  margin: 0;
  padding-bottom: 10px;
  font-size: 40px;
  line-height: 1.38;
  font-weight: 300;
  color: $white;

  @include media('<tablet') {
    @include set-fz-lh(26, 36);
  }
}

.heroTitle span {
  font-weight: 700;
}

.heroText {
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  color: $gray;

  @include media('<tablet') {
    font-size: 18px;
  }
}

.heroService {
  display: flex;
  justify-content: center;
}

.heroServiceItem {
  margin: 0 20px;
  text-align: center;

  @include media('<tablet') {
    margin: 0 10px;
  }
}

.heroServiceImg {
  @include media('<tablet') {
    width: 50px;
  }
}

.heroServiceText {
  margin: 0;
  font-size: 14px;
  line-height: 2.14;
  font-weight: 700;
  color: $white;
  text-transform: uppercase;

  @include media('<tablet') {
    font-size: 12px;
  }
}

.slider {
  max-height: 0;
  overflow: hidden;
  visibility: hidden;
  transition: max-height 0.5s linear;
}

.heroLink {
  cursor: pointer;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeHero.vue